import { useParams } from 'react-router-dom';
import { useIsInvoiceSubmitting } from '../../../../../../context/invoices/InvoiceLiveStatusContext';

export function useInvoiceSubmittingStatus() {
  const { id } = useParams();
  return useIsInvoiceSubmitting(id);
}